export default "__VITE_ASSET__25t3g3zQ__"